import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomerService } from '../../../../services';
import { ICustomerStructureData } from '../../../../interfaces/telephony/customer/customer-structure-data.dto.interface';
import { SelectItem } from 'primeng';

@Component({
  selector: 'app-customer-orders-filter',
  templateUrl: 'customer-orders-filter.component.html',
  styleUrls: ['../customer-information.component.scss'],
})
export class CustomerOrdersFilterComponent implements OnInit {
  constructor(private customerService: CustomerService) {}

  @Output() filterChanged = new EventEmitter<{ deptId: number; teamId: number; userId: string }>();

  isBusy = false;

  private _structure: ICustomerStructureData;
  @Input()
  get structure(): ICustomerStructureData {
    return this._structure;
  }

  set structure(value: ICustomerStructureData) {
    if (this._structure !== value) {
      this._structure = value;
      this.setDeptsAndTeams();
    }
  }

  depts: SelectItem[] = [];
  teams: SelectItem[] = [];
  users: SelectItem[] = [];

  selectedDept: number;
  selectedTeam: number;
  selectedUser: string;

  ngOnInit() {}

  setDeptsAndTeams() {
    this.depts = this.structure.departments.map((x) => {
      return { label: x.name, value: x.id };
    });
    this.depts.unshift({ label: 'Any Department', value: null });

    this.users = this.structure.users.map((x) => {
      return { label: x.userName, value: x.userId };
    });
    this.users.unshift({ label: 'Any User', value: null });
  }

  onSelectDept(deptId: any) {
    if (!deptId) {
      this.teams = [];
      this.selectedDept = deptId;
      this.onFilterChanged();
      return;
    }

    const dept = this.structure.departments.find((x) => x.id == deptId);
    this.teams = dept?.teams?.map((x) => {
      return { label: x.name, value: x.id };
    });
    this.teams.unshift({ label: 'Any Team', value: null });

    this.selectedDept = deptId;
    this.onFilterChanged();
  }

  onSelectTeam(teamId: any) {
    this.selectedTeam = teamId;
    this.onFilterChanged();
  }

  onSelectUser(userId: any) {
    this.selectedUser = userId;
    this.onFilterChanged();
  }

  onFilterChanged() {
    this.filterChanged.emit({
      deptId: this.selectedDept,
      teamId: this.selectedTeam,
      userId: this.selectedUser,
    });
  }

  resetFilters() {
    this.selectedTeam = null;
    this.selectedDept = null;
    this.selectedUser = null;
    this.onFilterChanged();
  }
}
